/*
===========================================================================
  Template Name   : Mombo
===========================================================================
*/ (function($) {
    "use strict";
    var MOM = {};
    var plugin_track = 'plugin/';
    $.fn.exists = function() {
        return this.length > 0;
    };
    /* ---------------------------------------------- /*
	 * Pre load
	/* ---------------------------------------------- */ MOM.PreLoad = function() {
        document.getElementById("loading").style.display = "none";
    };
    /*--------------------
        * Menu Close
    ----------------------*/ MOM.MenuClose = function() {
        $('.navbar-nav .nav-link').on('click', function() {
            var toggle = $('.navbar-toggler').is(':visible');
            if (toggle) $('.navbar-collapse').collapse('hide');
        });
    };
    /* ---------------------------------------------- /*
	 * Header Fixed
	/* ---------------------------------------------- */ MOM.HeaderFixd = function() {
        var HscrollTop = $(window).scrollTop();
        if (HscrollTop >= 100) $('header').addClass('fixed-header');
        else $('header').removeClass('fixed-header');
    };
    /*--------------------
        * One Page
    ----------------------*/ MOM.OnePage = function() {
        $('header a[href*="#"]:not([href="#"]), .got-to a[href*="#"]:not([href="#"])').on('click', function() {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') || location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 70
                    }, 1000);
                    return false;
                }
            }
        });
    };
    /* ---------------------------------------------- /*
	 * Search Box
	/* ---------------------------------------------- */ MOM.SearchBox = function() {
        var SearchToggle = $(".h_search");
        SearchToggle.on("click", function() {
            $('.h-search-section').toggleClass("searh-form-open");
        });
    };
    MOM.HeaderHeight = function() {
        var HHeight = $('.header-height').height();
        $('.page-title-top').css("margin-top", HHeight);
    };
    /* ---------------------------------------------- /*
	 * Mega Menu
	/* ---------------------------------------------- */ MOM.MegaMenu = function() {
        var mDropdown = $(".m-dropdown-toggle");
        mDropdown.on("click", function() {
            $(this).parent().toggleClass("open-menu-parent");
            $(this).next('ul').toggleClass("open-menu");
            $(this).toggleClass("open");
        });
    };
    /* ---------------------------------------------- /*
		* accordion
	/* ---------------------------------------------- */ MOM.Accordion = function() {
        $('.accordion').each(function(i, elem) {
            var $elem = $(this), $acpanel = $elem.find(".acco-group > .acco-des"), $acsnav = $elem.find(".acco-group > .acco-heading");
            $acpanel.hide().first().slideDown("easeOutExpo");
            $acsnav.first().parent().addClass("acco-active");
            $acsnav.on('click', function() {
                if (!$(this).parent().hasClass("acco-active")) {
                    var $this = $(this).next(".acco-des");
                    $acsnav.parent().removeClass("acco-active");
                    $(this).parent().addClass("acco-active");
                    $acpanel.not($this).slideUp("easeInExpo");
                    $(this).next().slideDown("easeOutExpo");
                } else {
                    $(this).parent().removeClass("acco-active");
                    $(this).next().slideUp("easeInExpo");
                }
                return false;
            });
        });
    };
    /*--------------------
    * Counter JS
    ----------------------*/ MOM.Counter = function() {
        var counter = jQuery(".counter");
        var $counter = $('.counter');
        if (counter.length > 0) loadScript(plugin_track + 'counter/jquery.countTo.js', function() {
            $counter.each(function() {
                var $elem = $(this);
                $elem.appear(function() {
                    $elem.find('.count').countTo({
                        speed: 2000,
                        refreshInterval: 10
                    });
                });
            });
        });
    };
    /*--------------------
    * OwlSlider
    ----------------------*/ MOM.Owl = function() {
        var owlslider = jQuery("div.owl-carousel");
        if (owlslider.length > 0) loadScript(plugin_track + 'owl-carousel/js/owl.carousel.min.js', function() {
            owlslider.each(function() {
                var $this = $(this), $items = $this.data('items') ? $this.data('items') : 1, $loop = $this.attr('data-loop') ? $this.data('loop') : true, $navdots = $this.data('nav-dots') ? $this.data('nav-dots') : false, $navarrow = $this.data('nav-arrow') ? $this.data('nav-arrow') : false, $autoplay = $this.attr('data-autoplay') ? $this.data('autoplay') : true, $autospeed = $this.attr('data-autospeed') ? $this.data('autospeed') : 5000, $smartspeed = $this.attr('data-smartspeed') ? $this.data('smartspeed') : 1000, $autohgt = $this.data('autoheight') ? $this.data('autoheight') : false, $CenterSlider = $this.data('center') ? $this.data('center') : false, $space = $this.attr('data-space') ? $this.data('space') : 30;
                $(this).owlCarousel({
                    loop: $loop,
                    items: $items,
                    responsive: {
                        0: {
                            items: $this.data('xx-items') ? $this.data('xx-items') : 1
                        },
                        480: {
                            items: $this.data('xs-items') ? $this.data('xs-items') : 1
                        },
                        768: {
                            items: $this.data('sm-items') ? $this.data('sm-items') : 2
                        },
                        980: {
                            items: $this.data('md-items') ? $this.data('md-items') : 3
                        },
                        1200: {
                            items: $items
                        }
                    },
                    dots: $navdots,
                    autoplayTimeout: $autospeed,
                    smartSpeed: $smartspeed,
                    autoHeight: $autohgt,
                    center: $CenterSlider,
                    margin: $space,
                    nav: $navarrow,
                    navText: [
                        "<i class='ti-arrow-left'></i>",
                        "<i class='ti-arrow-right'></i>"
                    ],
                    autoplay: $autoplay,
                    autoplayHoverPause: true
                });
            });
        });
    };
    /* ---------------------------------------------- /*
     * lightbox gallery
    /* ---------------------------------------------- */ MOM.Gallery = function() {
        if ($(".lightbox-gallery").exists() || $(".popup-youtube, .popup-vimeo, .popup-gmaps").exists()) loadScript(plugin_track + 'magnific/jquery.magnific-popup.min.js', function() {
            if ($(".lightbox-gallery").exists()) $('.lightbox-gallery').magnificPopup({
                delegate: '.gallery-link',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-fade',
                fixedContentPos: true,
                closeBtnInside: false,
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [
                        0,
                        1
                    ] // Will preload 0 - before current, and 1 after the current image
                }
            });
            if ($(".popup-youtube, .popup-vimeo, .popup-gmaps").exists()) $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        });
    };
    /*--------------------
    * Masonry
    ----------------------*/ MOM.masonry = function() {
        var portfolioWork = $('.portfolio-content');
        if ($(".portfolio-content").exists()) loadScript(plugin_track + 'isotope/isotope.pkgd.min.js', function() {
            if ($(".portfolio-content").exists()) {
                $(portfolioWork).isotope({
                    resizable: false,
                    itemSelector: '.grid-item',
                    layoutMode: 'masonry',
                    filter: '*'
                });
                //Filtering items on portfolio.html
                var portfolioFilter = $('.filter li');
                // filter items on button click
                $(portfolioFilter).on('click', function() {
                    var filterValue = $(this).attr('data-filter');
                    portfolioWork.isotope({
                        filter: filterValue
                    });
                });
                //Add/remove class on filter list
                $(portfolioFilter).on('click', function() {
                    $(this).addClass('active').siblings().removeClass('active');
                });
            }
        });
    };
    /*--------------------
        * Progress Bar 
    ----------------------*/ MOM.ProgressBar = function() {
        $(".skill-bar .skill-bar-in").each(function() {
            var bottom_object = $(this).offset().top + $(this).outerHeight();
            var bottom_window = $(window).scrollTop() + $(window).height();
            var progressWidth = $(this).attr('aria-valuenow') + '%';
            if (bottom_window > bottom_object) $(this).css({
                width: progressWidth
            });
        });
    };
    /*--------------------
        * pieChart
    ----------------------*/ MOM.pieChart = function() {
        var $Pie_Chart = $('.pie_chart_in');
        if ($Pie_Chart.exists()) loadScript(plugin_track + 'easy-pie-chart/jquery.easypiechart.min.js', function() {
            $Pie_Chart.each(function() {
                var $elem = $(this), pie_chart_size = $elem.attr('data-size') || "160", pie_chart_animate = $elem.attr('data-animate') || "2000", pie_chart_width = $elem.attr('data-width') || "6", pie_chart_color = $elem.attr('data-color') || "#84ba3f", pie_chart_track_color = $elem.attr('data-trackcolor') || "rgba(0,0,0,0.10)";
                $elem.find('span, i').css({
                    'width': pie_chart_size + 'px',
                    'height': pie_chart_size + 'px',
                    'line-height': pie_chart_size + 'px'
                });
                $elem.appear(function() {
                    $elem.easyPieChart({
                        size: Number(pie_chart_size),
                        animate: Number(pie_chart_animate),
                        trackColor: pie_chart_track_color,
                        lineWidth: Number(pie_chart_width),
                        barColor: pie_chart_color,
                        scaleColor: false,
                        lineCap: 'square',
                        onStep: function(from, to, percent) {
                            $elem.find('span.middle').text(Math.round(percent));
                        }
                    });
                });
            });
        });
    };
    /*--------------------
        * Countdown
    ----------------------*/ var $count_timer = $('.count-down');
    MOM.CountTimer = function() {
        if ($count_timer.exists()) loadScript(plugin_track + 'count-down/jquery.downCount.js', function() {
            $count_timer.downCount({
                date: '12/25/2022 12:00:00',
                offset: -4
            });
        });
    };
    /*--------------------
        * particles
    ----------------------*/ MOM.particles = function() {
        if ($("#particles-box").exists()) {
            loadScript(plugin_track + 'particles/particles.js', function() {});
            loadScript(plugin_track + 'particles/particles-app.js', function() {});
        }
    };
    /*-----------------------
    * Cookis
    -------------------------*/ MOM.Cookis = function() {
        loadScript(plugin_track + 'cookie/herbyCookie.js', function() {
            $(document).herbyCookie({
                heading: "COOKIE POLICY",
                btnText: "ACCEPT ALL",
                policyText: "Privacy policy",
                text: "We use cookies to ensure you get the best experience on our website, if you continue to browse you'll consent with our",
                scroll: false,
                expireDays: 30,
                link: "https://policies.swirepay.com/"
            });
        });
    };
    /* ---------------------------------------------- /*
	 * All Functions
	/* ---------------------------------------------- */ // loadScript
    var _arr = {};
    function loadScript(scriptName, callback) {
        if (!_arr[scriptName]) {
            _arr[scriptName] = true;
            var body = document.getElementsByTagName('body')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptName;
            // then bind the event to the callback function
            // there are several events for cross browser compatibility
            // script.onreadystatechange = callback;
            script.onload = callback;
            // fire the loading
            body.appendChild(script);
        } else if (callback) callback();
    }
    // Window on Load
    $(window).on("load", function() {
        MOM.masonry(), MOM.PreLoad();
    });
    // Document on Ready
    $(document).on("ready", function() {
        MOM.pieChart(), MOM.particles(), MOM.CountTimer(), MOM.HeaderFixd(), MOM.OnePage(), MOM.Accordion(), MOM.Counter(), MOM.MenuClose(), MOM.Gallery(), MOM.masonry(), MOM.SearchBox(), MOM.HeaderHeight(), MOM.MegaMenu(), MOM.ProgressBar(), MOM.Cookis(), MOM.Owl();
    });
    // Document on Scrool
    $(window).on("scroll", function() {
        MOM.ProgressBar(), MOM.HeaderFixd();
    });
    // Window on Resize
    $(window).on("resize", function() {
        MOM.HeaderHeight();
    });
})(jQuery);

//# sourceMappingURL=atea.3205a6b6.js.map
